import React, { useState } from "react";

import Subscription from "../../actions/Subscription";
import { useEffect } from "react";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import Loading from "../../components/customHelpers/Loading";
import Layout from "../../components/layout/Layout";
import Admin from "../../components/auth/Admin";
import { useHistory, useLocation } from "react-router-dom";
import SubscriptionDetails from "../admin/subscription/subscription";
import { Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const OrganizationSubscriptions = () => {
  const [subscription, setSubscription] = useState(null);
  const [counts, setCounts] = useState(null);
  const history = useHistory();
  const { viewOrgSubscription } = Subscription();

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  const { NotifyMessage, notify, setNotify } = Notify();
  let location = useLocation();

  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];
  useEffect(() => {
    getAllSubscriptions();
  }, [reload]);
  const getAllSubscriptions = () => {
    setValues({ ...values, loading: true });

    viewOrgSubscription(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({ ...values, loading: false });
      } else if (data.subscription) {
        
        setSubscription(data.subscription);
        setCounts(data.counts);
          console.log(data.counts)
        setValues({ ...values, loading: false });
      }
    });
  };
  console.log(counts)
  return (
    <Layout>
      <Admin>
        {loading ? (
          <Loading />
        ) : (
          <>
            <Typography variant="h6" className="page-header">
              <ArrowBackIcon
                style={{ cursor: "pointer" }}
                onClick={() => {
                  history.push("/admin/organization");
                }}
              ></ArrowBackIcon>{" "}
              <span style={{ marginLeft: "6px" }}>Organization Subscription</span>
            </Typography>
            <SubscriptionDetails counts={counts} subscriptionData={subscription} />
            <Notification notify={notify} setNotify={setNotify} />
          </>
        )}
      </Admin>
    </Layout>
  );
};

export default OrganizationSubscriptions;
